import { WebStorageStateStore, type UserManagerSettings } from 'oidc-client-ts'

/**
 * OIDC istemci ayarları (Auth Code + PKCE — research D6). Değerler yalnız env'den gelir (İlke II;
 * sır yok — public SPA client, PKCE). Redirect/post-logout verilmezse origin'den türetilir.
 *
 * - `automaticSilentRenew`: refresh token ile sessiz yenileme → F5 sonrası oturum sürer (FR-018).
 * - Token'lar localStorage'da tutulur → sekmeler/F5 arası oturum korunur (kütüphane yönetir).
 *
 * `metadataUrl`: THY'nin test IdP'si (Oracle Access Manager) discovery dokümanını standart
 * `.well-known/openid-configuration` (tekil) yerine `openid-configurations` (çoğul) altında
 * yayınlıyor — `oidc-client-ts`'in `authority`den otomatik türettiği standart yol hiç eşleşmez.
 * `VITE_OIDC_METADATA_URL` verildiğinde kütüphane discovery'yi bu adresten çeker (bkz. THY OIDC
 * entegrasyon dokümanı, sohbet notu 2026-08-11). **Doğrulanmadı:** THY'nin discovery endpoint'i
 * tarayıcıdan CORS'a açık mı bilinmiyor — kapalıysa `metadataUrl` başarısız olur ve tam `metadata`
 * nesnesiyle (endpoint'ler elle) değiştirilmesi gerekir; ayrıca THY dokümanı `end_session_endpoint`
 * (logout) değerini literal vermiyor, discovery'den okunması bekleniyor.
 */
// `??` yerine `||` (dördü de) — docker-compose'un `${VAR:-}` geçişi, değişken .env'de hiç tanımlı
// olmasa bile build'e boş string ("") basabiliyor; `??` bunu "değer var" sayıp varsayılana düşmez.
// `redirect_uri`/`post_logout_redirect_uri` için bu 2026-08-12'de RDC dev'de gözlemlenip düzeltilmişti;
// `authority`/`client_id` şu an docker-compose'da `:-` fallback'i yok (her zaman `.env`'den dolu gelir)
// ama aynı sınıfa açık kalmasın diye (VITE_API_URL'de 2026-08-15'te tam bu şekilde patladı —
// bkz. `api/client.ts`) tutarlılık için buraya da uygulandı.
const authority = import.meta.env.VITE_OIDC_AUTHORITY || ''
const metadataUrl = import.meta.env.VITE_OIDC_METADATA_URL
const clientId = import.meta.env.VITE_OIDC_CLIENT_ID || ''
const redirectUri =
  import.meta.env.VITE_OIDC_REDIRECT_URI || `${window.location.origin}/auth/callback`
const postLogoutRedirectUri =
  import.meta.env.VITE_OIDC_POST_LOGOUT_REDIRECT_URI || window.location.origin

export const oidcSettings: UserManagerSettings = {
  authority,
  ...(metadataUrl ? { metadataUrl } : {}),
  client_id: clientId,
  redirect_uri: redirectUri,
  post_logout_redirect_uri: postLogoutRedirectUri,
  response_type: 'code',
  scope: 'openid profile email',
  automaticSilentRenew: true,
  userStore: new WebStorageStateStore({ store: window.localStorage }),
}
